import type { RouteRecordName } from 'vue-router'

import { pathNames } from '@/shared/utils/constants'

type RouteNameGetter = () => RouteRecordName | null | undefined

let getCurrentRouteName: RouteNameGetter = () => undefined

/** Bound from app router bootstrap to avoid static `@/app/router` import cycles. */
export const setCallSessionRouteNameGetter = (getter: RouteNameGetter): void => {
  getCurrentRouteName = getter
}

export const isCallSessionRouteName = (name: RouteRecordName | null | undefined): boolean => (
  name === pathNames.CALL_SESSION || name === pathNames.GUEST_CALL_SESSION
)

export const isOnCallSessionRoute = (): boolean => (
  isCallSessionRouteName(getCurrentRouteName())
)
